import {
  css,
  FlattenSimpleInterpolation,
  FlattenInterpolation,
  ThemeProps,
} from 'styled-components';

export const SCREEN_XS = 0;
export const SCREEN_SM = 375;
export const SCREEN_MD = 768;
export const SCREEN_LG = 1280;
export const SCREEN_XL = 1920;

type CompositeInterpolation =
  | FlattenSimpleInterpolation
  | FlattenInterpolation<ThemeProps<any>>;

export const smAndDown = (content: CompositeInterpolation) => css`
  @media (max-width: ${SCREEN_SM}px) {
    ${content}
  }
`;

export const smAndUp = (content: CompositeInterpolation) => css`
  @media (min-width: ${SCREEN_SM}px) {
    ${content}
  }
`;

export const smOnly = (content: CompositeInterpolation) => css`
  @media (max-width: ${SCREEN_SM}px) {
    ${content}
  }
`;

export const mdAndDown = (content: CompositeInterpolation) => css`
  @media (max-width: ${SCREEN_LG - 1}px) {
    ${content}
  }
`;

export const mdAndUp = (content: CompositeInterpolation) => css`
  @media (min-width: ${SCREEN_MD}px) {
    ${content}
  }
`;

export const mdOnly = (content: CompositeInterpolation) => css`
  @media (min-width: ${SCREEN_MD}px) and (max-width: ${SCREEN_LG - 1}px) {
    ${content}
  }
`;

export const lgAndDown = (content: CompositeInterpolation) => css`
  @media (max-width: ${SCREEN_XL - 1}px) {
    ${content}
  }
`;

export const lgAndUp = (content: CompositeInterpolation) => css`
  @media (min-width: ${SCREEN_LG}px) {
    ${content}
  }
`;

export const lgOnly = (content: CompositeInterpolation) => css`
  @media (min-width: ${SCREEN_LG}px) {
    ${content}
  }
`;

export const mobileOnly = smAndDown;

export const mobileAndTablet = mdAndDown;

export const tabletOnly = mdOnly;

export const tabletAndDesktop = mdAndUp;

export const desktopOnly = lgAndUp;
